export default __webpack_public_path__ + "static/business_insider-f796bc6f692eae82703b7ab65fac19a8.svg";